var map = {
	"./apple.png": 5321,
	"./facebook.png": 5089,
	"./instagram.png": 4301,
	"./soundcloud.png": 9445,
	"./spotify.png": 871,
	"./twitch.png": 6024,
	"./twitter.png": 8564,
	"./youtube.png": 7310
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9945;